export enum StudentTabId {
	Classes = 'classes',
	Groups = 'groups',
	Students = 'students',
}

export type StudentType = {
	id: number;
	firstName: string;
	lastName: string;
	gradeLevelID: number;
	teacherID: number;
	schoolID: number;
	avatarURL?: string;
};

export type ClassType = {
	id: number;
	name: string;
	studentIDs: StudentType['id'][];
};

export type GroupType = {
	id: number;
	name: string;
	classID: number;
	studentIDs: StudentType['id'][];
};

export type InitStudentsResponse = {
	classes: ClassType[];
	groups: GroupType[];
	students: StudentType[];
};
